import type { AxiosError, InternalAxiosRequestConfig } from 'axios';

/**
 * Marker the Tier-1 auth handler stamps on a request config it has already
 * replayed once after a 401. A second 401 on a stamped config is a definitive
 * session-dead signal that force-logs the user out, so no other retry
 * mechanism may replay a stamped config.
 */
export type AuthRetriedConfig = InternalAxiosRequestConfig & {
  __authRetryAttempted?: boolean;
};

export const wasRetriedByAuthHandler = (error: AxiosError): boolean =>
  (error.config as AuthRetriedConfig | undefined)?.__authRetryAttempted === true;
